import { render, staticRenderFns } from "./TasksSchedule.vue?vue&type=template&id=bfd33c30"
import script from "./TasksSchedule.vue?vue&type=script&lang=js"
export * from "./TasksSchedule.vue?vue&type=script&lang=js"
import style0 from "./TasksSchedule.vue?vue&type=style&index=0&id=bfd33c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports